import api from "../data/api/mainApi";

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export async function millingAsset(dxfKey, mode = "2d") {
  if (!dxfKey) return null;

  const key = encodeURIComponent(dxfKey);

  // Először mindig biztosítjuk, hogy elkészüljön a render.
  const { data: job } = await api.post(`/millings/dxf/${key}/render/${mode}`);

  if (!job?.id) {
    throw new Error("A DXF render indítása nem adott vissza job ID-t.");
  }

  let current = job;

  while (current.status !== "done") {
    if (current.status === "error") {
      throw new Error(current.error || "A DXF renderelése nem sikerült.");
    }

    await sleep(500);

    const response = await api.get(
      `/millings/dxf/jobs/${encodeURIComponent(job.id)}`
    );

    current = response.data;
  }

  const { data } = await api.get(`/millings/dxf/${key}/render/${mode}`);

  return data;
}

export async function millingImage(key) {
  const response = await api.get(
    `/millings/images/${encodeURIComponent(key)}/mask`,
    { responseType: "blob" }
  );
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve({ kind: "shade", image: reader.result });
    reader.onerror = reject;
    reader.readAsDataURL(response.data);
  });
}
export async function millingImageSize(milling) {
  if (milling.imageWidthMm > 0 && milling.imageHeightMm > 0) return [milling.imageWidthMm,milling.imageHeightMm];
  if (milling.dxfKey) {
    const { data } = await api.get(`/millings/dxf/${encodeURIComponent(milling.dxfKey)}/size`);
    if (data.size?.[0]>0 && data.size?.[1]>0) return data.size;
  }
  throw new Error("Add meg a marás képének eredeti szélességét és magasságát a Marásmintáknál.");
}

export function mainMilling(item, catalog) {
  const id = item.milling?.millingId ?? item.millingId;
  return (
    catalog.find((m) => String(m.millingId) === String(id)) || item.milling
  );
}
